
import { Vue, Component, Watch, Ref } from 'vue-property-decorator';
import lazyInject from '@/di';
import { warkLabel } from '@/models/wark';
import { AccountService } from '@/services/account_service';
import moment from 'moment';
import WorkbenchesService from '@/services/workbenches.service';
import LookGoodDrawer from '@/views/workbenches/subassembly/LookGoodDrawer.vue';
import LookCPSShopDrawer from '@/views/workbenches/subassembly/LookCPSShopDrawer.vue';

import { CPSInvestmentPromotionModel } from '@/models/wark.model';
import { getCurrentMonth, getDateMonth } from '@/common/utils';
import { AuthEnum } from '@/services/permission.service';


@Component({
  components: {
    LookGoodDrawer,
    LookCPSShopDrawer,
  },
})
export default class CPSInvestmentPromotion extends Vue {
  @lazyInject(WorkbenchesService)
  workbenchesService!: WorkbenchesService;


  @lazyInject(AccountService)
  protected accountService!: AccountService;

  @Ref()
  lookGoodDrawer!: LookGoodDrawer;

  @Ref()
  lookCPSShopDrawer!: LookCPSShopDrawer;

  AuthEnum = AuthEnum;

  refresh() {
    this.getQuery();
  }

  moment = moment;

  activityTotal: any = '0';

  typeChild: string | null = localStorage.getItem('typeChild');

  columns = [
    ...warkLabel.init('CPSInvestmentPromotion').supplementTitleColumns,
    ...warkLabel.init('CPSInvestmentPromotion').titleColumns,
  ];

  module: any = '';

  data: any = [];

  pagination: any = {
    total: 0,
    current: 1,
    pageSize: 10,
    showSizeChanger: true,
    pageSizeOptions: this.$store.state.pageSize.pageSize,
    onShowSizeChange: this.onShowSizeChange,
    onChange: this.onChange,
  };

  filterForm: any = {
    month: '',
    group_id: undefined,
    dept_id: undefined,
    department: '',
    group: '',
    name: '',
    goods_name: '',
    spu_id: '',
    agent_name: '',
  };

  dept_list: any = [];

  group_list: any = [];

  permissionOptions: any = [];
  permissionListOfRole: any = [];

  @Watch('$route.query')
  onRouteChange() {
    const { module, page, pageSize, month, dept_id, group_id, user_name, name, goods_name, spu_id, agent_name } = this.$route.query;
    this.module = module;
    const queryParams: any = {
      page: page || 1,
      pageSize: pageSize || 10,
      module,
    };
    if (month) {
      queryParams.month = month;
      this.filterForm.month = month;
    } else {
      queryParams.month = getCurrentMonth();
      this.filterForm.month = getCurrentMonth();
    }
    if (dept_id) {
      queryParams.dept_id = dept_id;
      this.filterForm.dept_id = +dept_id;
    }
    if (group_id) {
      queryParams.group_id = group_id;
      this.filterForm.group_id = +group_id;
    }
    if (user_name) {
      queryParams.user_name = user_name;
      this.filterForm.user_name = user_name;
    }
    if (name) {
      queryParams.name = name;
      this.filterForm.name = name;
    }
    if (goods_name) {
      queryParams.goods_name = goods_name;
      this.filterForm.goods_name = goods_name;
    }
    if (agent_name) {
      queryParams.agent_name = agent_name;
      this.filterForm.agent_name = agent_name;
    }
    if (spu_id) {
      queryParams.spu_id = spu_id;
      this.filterForm.spu_id = spu_id;
    }
    this.getList(queryParams);
  }

  async exportData() {
    const queryParams: any = {
      module: this.module,
      export: 1,
    };
    const { month, dept_id, group_id, user_name, name, goods_name, spu_id, agent_name } = this.filterForm;
    if (month) {
      queryParams.month = month;
    }
    if (dept_id) {
      queryParams.dept_id = dept_id;
    }
    if (group_id) {
      queryParams.group_id = group_id;
    }
    if (user_name) {
      queryParams.user_name = user_name;
    }
    if (name) {
      queryParams.name = name;
    }
    if (goods_name) {
      queryParams.goods_name = goods_name;
    }
    if (spu_id) {
      queryParams.spu_id = spu_id;
    }
    if (agent_name) {
      queryParams.agent_name = agent_name;
    }
    await this.workbenchesService.getQuickEntranceExport(queryParams, 'CPS标品招商数据');
  }

  async searchPermission(value: string) {
    try {
      const res = await this.accountService.getLeaderList({
        page: 1,
        pageSize: 1000,
        userName: value,
      });
      this.permissionOptions = res.list;
    } catch (error) {
      // console.log(error);
    }
  }


  showType(row: any) {
    const data = new Date();
    const { month } = row;
    return month === getDateMonth(data);
  }

  async getDeptInfo() {
    const res = await this.workbenchesService.getDeptInfo();
    this.dept_list = res;
    const { dept_id } = this.$route.query;
    if (!dept_id) return;
    const deptId = Number(dept_id);
    this.group_list = this.dept_list.find((item: any) => item.dept.id === deptId).group;
  }
  selectOption(val: any) {
    this.group_list = this.dept_list.find((res: any) => res.dept.id === val).group;
    this.filterForm.group_id = undefined;
  }

  changeMonth(val: any) {
    const year = val._d.getFullYear(); // 获取当前年份，例如：2021
    let month: any = Number(val._d.getMonth()) + 1; // 获取当前月份，注意需要加1，例如：9
    if (month < 10) {
      month = `0${month}`;
    }
    const _d = `${year}-${month}`;
    this.filterForm.month = _d;
  }

  async getList(queryParams: any) {
    const res = await this.workbenchesService.getQuickEntrance(queryParams, this.$el);
    this.data = CPSInvestmentPromotionModel.from(res.list);
    this.data = this.data.map((item: any) => addmouth(item));
    function addmouth(val: any) {
      const _val = val;
      _val.month = queryParams.month;
      return _val;
    }
    this.activityTotal = res.ka_ds_cps;
  }

  getQuery() {
    const { current, pageSize } = this.pagination;
    const { month, dept_id, group_id, user_name, name, goods_name, spu_id, agent_name } = this.filterForm;
    const queryParams: any = {
      page: current,
      pageSize,
      module: this.module,
    };
    if (month) {
      queryParams.month = month;
    }
    if (dept_id) {
      queryParams.dept_id = dept_id;
    }
    if (group_id) {
      queryParams.group_id = group_id;
    }
    if (user_name) {
      queryParams.user_name = user_name;
    }
    if (name) {
      queryParams.name = name;
    }
    if (goods_name) {
      queryParams.goods_name = goods_name;
    }
    if (spu_id) {
      queryParams.spu_id = spu_id;
    }
    if (agent_name) {
      queryParams.agent_name = agent_name;
    }
    queryParams.timestamp = Math.round(Date.now() / 1000);
    this.$router.push({
      query: queryParams,
    });
  }
  search() {
    this.pagination.current = 1;
    this.getQuery();
  }
  onChange(page: number, pageSize: number) {
    this.pagination.current = page;
    this.pagination.pageSize = pageSize;
    this.getQuery();
  }
  onShowSizeChange(page: number, pageSize: number) {
    this.pagination.current = 1;
    this.pagination.pageSize = pageSize;
    this.getQuery();
  }

  resetQuery() {
    this.filterForm = {
      month: '',
      dept_id: undefined,
      group_id: undefined,
      user_name: '',
      name: '',
      goods_name: '',
      spu_id: '',
      agent_name: '',
    };
    this.pagination.current = 1;
    this.getQuery();
  }

  back() {
    this.$router.push({ name: 'workbenches.index' });
  }

  changeColumns(val: string) {
    switch (val) {
      case 'director': // 总监
        this.columns = [
          ...warkLabel.init('CPSInvestmentPromotion').department,
          ...warkLabel.init('CPSInvestmentPromotion').groupLeader,
          ...warkLabel.init('CPSInvestmentPromotion').titleColumns,
        ];
        break;
      case 'assistantDirector': // 助理
        this.columns = [
          ...warkLabel.init('CPSInvestmentPromotion').department,
          ...warkLabel.init('CPSInvestmentPromotion').groupLeader,
          ...warkLabel.init('CPSInvestmentPromotion').titleColumns,
        ];
        break;
      case 'kaTeamLeader': // 部长
        this.columns = [
          ...warkLabel.init('CPSInvestmentPromotion').department,
          ...warkLabel.init('CPSInvestmentPromotion').groupLeader,
          ...warkLabel.init('CPSInvestmentPromotion').titleColumns,
        ];
        break;
      case 'ordinaryTeamMinister': // 部长
        this.columns = [
          ...warkLabel.init('CPSInvestmentPromotion').department,
          ...warkLabel.init('CPSInvestmentPromotion').groupLeader,
          ...warkLabel.init('CPSInvestmentPromotion').titleColumns,
        ];
        break;
      case 'kaTeamMinister': // 组长
        this.columns = [
          ...warkLabel.init('CPSInvestmentPromotion').supplementGroupLeader,
          ...warkLabel.init('CPSInvestmentPromotion').groupLeader,
          ...warkLabel.init('CPSInvestmentPromotion').titleColumns,
        ];
        break;
      case 'ordinaryTeamLeader': // 组长
        this.columns = [
          ...warkLabel.init('CPSInvestmentPromotion').supplementGroupLeader,
          ...warkLabel.init('CPSInvestmentPromotion').groupLeader,
          ...warkLabel.init('CPSInvestmentPromotion').titleColumns,
        ];
        break;
      default: // 普通
        this.columns = [
          ...warkLabel.init('CPSInvestmentPromotion').supplementTitleColumns,
          ...warkLabel.init('CPSInvestmentPromotion').titleColumns,
        ];
        break;
    }
    const obj: any = {
      dept_name: 'dept_id',
      dept_manager: 'dept_id',
      dept_target_quota: 'dept_id',
      dept_activity_num: 'dept_id',
      dept_ratio: 'dept_id',
      group_name: 'group_id',
      group_manager: 'group_id',
      group_target_quota: 'group_id',
      group_activity_num: 'group_id',
      group_ratio: 'group_id',
    };
    this.columns.forEach((res: any) => {
      if (Object.prototype.hasOwnProperty.call(obj, res.dataIndex)) {
        res.customRender = (text: any, row: any, index: any) => {
          return this.customRender(text, row, index, obj[res.dataIndex]);
        };
      }
    });
  }
  customRender(text: any, row: any, index: any, column: any) {
    const prevRow: any = this.data[index - 1];
    if (prevRow && prevRow[column] === row[column]) {
      return {
        children: text,
        attrs: {
          rowSpan: 0,
        },
      };
    }
    let rowSpan = 1;
    const _i: number = index;
    for (let i = _i + 1; i < this.data.length; i++) {
      const currentRow: any = this.data[i];
      if (currentRow[column] === row[column]) {
        rowSpan++;
      } else {
        break;
      }
    }
    return {
      children: text,
      attrs: {
        rowSpan,
      },
    };
  }

  mounted() {
    this.changeColumns(this.typeChild!);
    this.getDeptInfo();
    this.onRouteChange();
  }

  lookGoods(row: any) {
    this.lookGoodDrawer.init(row);
  }

  lookCPSShop(row: any) {
    this.lookCPSShopDrawer.init(row);
  }
}
